import type { ComponentProps } from 'react'
import { motion } from 'motion/react'
import type { ShopMessageKey } from '../../../i18n'
import { customerMotionTransition } from '../customer-area'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

type CustomerOrderDetailErrorStateProps = {
  prefersReducedMotion: boolean
  contentTransition: ComponentProps<typeof motion.div>['transition']
  error: string
  onBackToOrders: () => void
  t: TranslateFn
}

export const CustomerOrderDetailErrorState = ({
  prefersReducedMotion,
  contentTransition,
  error,
  onBackToOrders,
  t,
}: CustomerOrderDetailErrorStateProps) => (
  <motion.div
    key="order-detail-error"
    initial={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
    animate={prefersReducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
    exit={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: -8 }}
    transition={contentTransition}
    className="rounded-2xl border border-(--color-status-error-border) bg-(--color-status-error-bg) px-4 py-3 text-sm text-(--color-status-error)"
  >
    <div className="flex flex-wrap items-center justify-between gap-3">
      <span>{error}</span>
      <motion.button
        type="button"
        onClick={onBackToOrders}
        whileTap={prefersReducedMotion ? undefined : { scale: 0.985 }}
        transition={customerMotionTransition}
        className="ca-theme-transition rounded-full border border-(--color-status-error-border) px-3 py-1 text-xs font-semibold hover:bg-[color-mix(in_srgb,var(--color-status-error-bg)_85%,transparent)]"
      >
        {t('customer.orderDetail.toOrders')}
      </motion.button>
    </div>
  </motion.div>
)
